import {Button, Col, Divider, Row} from "antd";
import {useContext, useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import AppContext from "../../../context/app/context";
import GeneralSettingContext from "../../../context/general-setting/context";
import GeneralSettingContextProvider from "../../../context/general-setting/provider";
import {IUpdateGeneralSetting} from "../../../models/general-setting/request";
import {languages} from "../../../utils/helpers/constants";
import FieldBuilder from "../../form-components/field-builder";
import Spin from "../../general/antd/spin";
import {getTranslations} from "../../../utils/helpers/translations";
import FormItem from "../../general/form-item";
import Controller from "../../form-components/controller";
import ImageUploader from "../../form-components/image-uploader";
import {MediumFor} from "../../../models/medium/enum";
import OldImage from "../../form-components/old-image";
import EndPoints from "../../../services/end-points";
import {IDiscountCode} from "../../../models/discount-code/response";
import RichEditor from "../../form-components/rich-text-editor";
import {FormProvider, useForm} from "react-hook-form";
import {execute} from "../../../utils/helpers/execute";
import styles from "./style.module.scss";
import {DeleteOutlined, LoadingOutlined} from "@ant-design/icons";

const Form = () => {
  const {t} = useTranslation();
  const [discountCode, setDiscountCode] = useState<IDiscountCode[]>([]);
  const [discountCodeLoading, setDiscountCodeLoading] = useState(true);
  const {direction} = useContext(AppContext);
  const {list, actions, loading} = useContext(GeneralSettingContext);

  const [hasMore, setHasMore] = useState(true);
  const [query, setQuery] = useState({page: 1, search: undefined});
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [imageLoading, setImageLoading] = useState<Record<string, boolean>>({});

  const methods = useForm<any>({
    defaultValues: {
      phone: list?.phone,
      telegram: list?.telegram,
      whatsApp: list?.whatsApp,
      instagram: list?.instagram,
      welcomeMessageActivation: list?.welcomeMessageActivation ?? false,
      welcomeMessage: getTranslations(list?.translations?.welcomeMessage),
      weAre: getTranslations(list?.translations?.whoWeAre),
      ourAchievements: getTranslations(list?.translations?.ourAchievements),

    } as IUpdateGeneralSetting,
  });

  const {handleSubmit, reset, setValue} = methods;

  const handleImageDelete = async (fieldName: string) => {
    try {
      setImageLoading(prev => ({...prev, [fieldName]: true}));

      // const currentValues = methods.getValues();
      // await actions.updateGeneralSetting({
      //     ...currentValues,
      //     [fieldName]: null
      // });

      methods.setValue(fieldName, null);
      if (list) {
        list[fieldName] = null;
      }
    } finally {
      setImageLoading(prev => ({...prev, [fieldName]: false}));
    }
  };

  useEffect(() => {
    reset({
      phone: list?.phone,
      telegram: list?.telegram,
      whatsApp: list?.whatsApp,
      instagram: list?.instagram,

      welcomeMessageActivation: list?.welcomeMessageActivation ?? false,
      welcomeMessage: getTranslations(list?.translations?.welcomeMessage),
      weAre: getTranslations(list?.translations?.whoWeAre),
      ourAchievements: getTranslations(list?.translations?.ourAchievements),
    } as IUpdateGeneralSetting);
  }, [list]);

  const onSubmit = async (data: any) => {
    await execute({
      callback: async () => {
        setLoadingSubmit(true);
        await actions.updateGeneralSetting({
          ...data,
          clientAcceptanceTime: Number(data?.clientAcceptanceTime),
          welcomeCoupon: data?.welcomeCoupon || null,
        });
      },
      fallback: (error) => {
      },
      finallyCallback: () => {
        setLoadingSubmit(false);
      },
      throwException: false,
    });
  };

  useEffect(() => {
    const getGeneralSetting = async () => {
      await actions.getGeneralSetting();
    };
    getGeneralSetting();
  }, [direction]);

  // get all discount code  from api
  // const handleScroll = (e) => {
  //   const {scrollTop, clientHeight, scrollHeight} = e.target;
  //   if (
  //       scrollHeight - scrollTop === clientHeight &&
  //       hasMore &&
  //       !discountCodeLoading
  //   ) {
  //     setQuery({...query, page: query.page + 1});
  //   }
  // };
  //
  // const handleSearch = (value) => {
  //   setQuery({page: 1, search: value});
  //   setDiscountCode([]);
  // };
  //
  // const getDiscountCode = async () => {
  //   try {
  //     const {data} = await EndPoints.discountCode.getAllDiscountCode({
  //       light: true,
  //       page: query.page,
  //       perPage: 200,
  //       keyword: query?.search == "" ? undefined : query?.search,
  //     });
  //     const newOptions = data?.data;
  //     setDiscountCode((prevOptions) => [...prevOptions, ...newOptions]);
  //     setHasMore(data.lastPage == query.page ? false : true);
  //     setDiscountCodeLoading(false);
  //   } catch (error) {
  //   } finally {
  //     setDiscountCodeLoading(false);
  //   }
  // };
  //
  // useEffect(() => {
  //   getDiscountCode();
  // }, [direction, query]);

  return (
      <FormProvider {...methods}>
        <form className={styles.container} onSubmit={handleSubmit(onSubmit)}>
          <div>
              <span className={styles.title}>
                {t("update_general_settings")}
              </span>
            <Divider className={styles.divider}/>
            {loading.includes("list") ? (
                <div style={{height: "60vh"}}>
                  <Spin/>
                </div>
            ) : (
                <div className={styles.children}>
                  <Row gutter={[8, 8]}>
                    <Col span={8}>
                      <FieldBuilder
                          name="facebook"
                          label={t("facebook")}
                          input={{type: "text"}}
                      />
                    </Col>
                    <Col span={8}>
                      <FieldBuilder
                          name="instagram"
                          label={t("instagram")}
                          input={{type: "text"}}
                      />
                    </Col>
                    <Col span={8}>
                      <FieldBuilder
                          name="phone"
                          label={t("phone")}
                          input={{type: "text"}}
                      />
                    </Col>
                    <Col span={8}>
                      <FieldBuilder
                          name="hotLine"
                          label={t("hotLine")}
                          input={{type: "text"}}
                          rules={{required: false, minLength: 4, maxLength: 7}}
                      />
                    </Col>
                    <Col span={8}>
                      <FieldBuilder
                          name="telegram"
                          label={t("telegram")}
                          input={{type: "text"}}
                      />
                    </Col>
                    <Col span={8}>
                      <FieldBuilder
                          name="whatsApp"
                          label={t("whatsApp")}
                          input={{type: "text"}}
                      />
                    </Col>
                    {languages?.map((lang, index) => {
                      return (
                          <Col span={12}>
                            <FieldBuilder
                                key={index}
                                name={`welcomeMessage[${lang?.code}]`}
                                label={`${t("welcome_message")} (${lang?.name})`}
                                input={{type: "text"}}
                            />
                          </Col>
                      );
                    })}
                    {languages?.map((lang, index) => {
                      return (
                          <Col span={12}>
                            <FieldBuilder
                                key={index}
                                name={`weAre[${lang?.code}]`}
                                label={`${t("we_are")} (${lang?.name})`}
                                input={{type: "text"}}
                            />
                          </Col>
                      );
                    })}
                    {languages?.map((lang, index) => {
                      return (
                          <Col span={12}>
                            <FieldBuilder
                                key={index}
                                name={`ourAchievements[${lang?.code}]`}
                                label={`${t("our_achievements")} (${lang?.name})`}
                                input={{type: "text"}}
                            />
                          </Col>
                      );
                    })}
                    <Col span={8}>
                      <FieldBuilder
                          label={`${t("welcomeMessageActivation")}`}
                          name="welcomeMessageActivation"
                          input={{type: "checkBox"}}
                      />
                    </Col>
                    <Col span={8}>
                      <FieldBuilder
                          label={`${t("welcomeCouponActive")}`}
                          name="welcomeCouponActive"
                          input={{type: "checkBox"}}
                      />
                    </Col>
                  </Row>
                </div>
            )}
          </div>
          <div>
            <Divider className={styles.divider}/>
            <div className={styles.formFooter}>
              <Button
                  onClick={() => {
                    reset();
                  }}
              >
                {t("cancel")}
              </Button>
              <Button loading={loadingSubmit} htmlType="submit" type="primary">
                {t("save")}
              </Button>
            </div>
          </div>
        </form>
      </FormProvider>
  );
};


const GeneralSettingForm = () => {
  return (
      <GeneralSettingContextProvider>
        <Form/>
      </GeneralSettingContextProvider>
  );
};
export default GeneralSettingForm;
